import { gql } from 'graphql.macro';

export const CreateGoodPractice = gql`
    mutation createGoodPractice($request: GoodPracticeRequestModelInput) {
        createGoodPractice(request: $request) {observationId, uniqueRecordId}
    }
`;